import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

import { ProcedureService, MessageService } from '@services';

/**
 * Componente para la bandeja con el listado de solicitudes a validar por parte del funcionario
 */
@Component({
  selector: 'app-validator-dashboard',
  templateUrl: './validator-dashboard.component.html',
  styleUrls: ['./validator-dashboard.component.scss'],
})
export class ValidatorDashboardComponent implements OnInit, AfterViewInit {

  /**
   * Paginador de la bandeja
   */
  @ViewChild(MatPaginator) paginator: MatPaginator;

  /**
   * Objeto para ordenar los tramites de la bandeja
   */
  @ViewChild(MatSort) sort: MatSort;

  /**
   * Formulario con los filtros de busqueda
   */
  public validatorForm: FormGroup;

  /**
   * Lista con las solicitudes a mostrar en el dashboard
   */
  public tableFilter: any[] = [];

  /**
   * Centinela para mostrar u ocultar la pantalla de validacion
   */
  public showFormByUser: boolean = false;

  /**
   * Objeto del tramite a validar seleccionado por el funcionario
   */
  public tramiteSeleccionado: any;

  /**
   * Opciones para el total de registros por página
   */
  public pageSizeOptions: number[] = [10, 25, 50, 100];

  /**
   * Cantidad de solicitudes por pagina
   */
  public pageSizePaginator: number = 10;

  /**
   * Número total de solicitudes
   */
  public totalRequests: number;


  constructor(
    private fb: FormBuilder,
    private procedureService: ProcedureService,
    private popUpService: MessageService,
  ) {
    this.validatorForm =  this.fb.group({
      textToSearch: [''],
      pageSize: [this.pageSizePaginator],
      pageNumber: [1],
    });
  }

  /**
   * Hook cuando el componente ya se construyó pero no ha renderizado
   */
  ngOnInit(): void {
    this.getListaTramites();
  }

  /**
   * Hook cuando el componente ya renderizó todas las vistas
   */
  ngAfterViewInit(): void {
    this.paginator._intl.getRangeLabel = this.getRangeDisplayText;
  }


  /**
   * Consulta las solicitudes a mostrar
   */
  public getListaTramites(): void {

    //Data para el paginador del backend
    let data = {
      pageSize: this.validatorForm.get('pageSize').value,
      pageNumber: this.validatorForm.get('pageNumber').value,
      textToSearch: this.validatorForm.get('textToSearch').value,
    };


    this.popUpService.infoAlert('Buscando tramites...', 4000);

    this.procedureService.getFilterGetAllDashboard(data).subscribe((values) => {
      this.tableFilter = values['items'];
      this.totalRequests = values['totalRows'];

      if(this.totalRequests == 0){
        this.popUpService.errorAlert("No existen solicitudes con los filtros aplicados",3000)
      }

    });
  }


  /**
   * Cambia la página en la tabla actualizando su información
   * @param e Evento del paginador
   */
  cambiarPaginaPaginador(e: PageEvent) {
    this.validatorForm.get('pageNumber').setValue(e.pageIndex + 1);
    this.getListaTramites();
  }

  /**
   * Actualiza la lista de solicitudes
   */
  public changeDataTable(): void {
    this.pageSizePaginator = this.validatorForm.get('pageSize').value;
    this.validatorForm.get('pageNumber').setValue(1);
    this.paginator.firstPage();
    this.getListaTramites();
  }

  /**
   * Carga la pestaña de validación con el tramite seleccionado
   * @param id
   */
  getTramiteActual(id): void {
    this.popUpService.infoAlert('Cargando tramite...', 4000);
    this.procedureService.getById(id).subscribe((resp) => {
      this.tramiteSeleccionado = resp;
      this.showFormByUser = true;
    });
  }

  /**
   * Oculta la pantalla de validación y muestra la bandeja de solicitudes
   */
  public volver(): void {
    this.showFormByUser = false;
  }

  /**
   * Pinta y coloca el texto para el semaforo de las solicitudes en la bandeja
   * @param diaspasados Dias trasncuridos desde la ultima fecha de actualizacion de la solicitud
   * @param i Iterador para identificar cada celda del semaforo
   */
  public changeColor(diaspasados,i): string{
    let mensajeDias = "";
    let color = document.getElementById(`color_${i}`);
    if (diaspasados <= 9) {
      mensajeDias =  `Quedan `+ (20 - diaspasados) + ` días. Días transcurridos ${diaspasados}`;
      // tslint:disable-next-line: no-unused-variable
      (<HTMLElement>color).style.backgroundColor="#d1e7dd";
    } else if (diaspasados >= 10 && diaspasados <= 14) {
      mensajeDias =   `¡Atención usuario! Trámite próximo a vencerse. quedan ` +(20 - diaspasados) +`. Dias transcurridos ${diaspasados}`;
      // tslint:disable-next-line: no-unused-variable
      (<HTMLElement>color).style.backgroundColor="#fff3cd";
    } else if (diaspasados >= 15 && diaspasados <= 20) {
      mensajeDias =  `¡Atención usuario! Trámite próximo a vencerse. quedan ` +(20 - diaspasados) +`. Dias transcurridos ${diaspasados}`;
      // tslint:disable-next-line: no-unused-variable
      (<HTMLElement>color).style.backgroundColor="#f8d7da";
    } else {
      mensajeDias =  `¡Atención usuario! El trámite se encuentra vencido. Dias transcurridos ${diaspasados}`;
      // tslint:disable-next-line: no-unused-variable
      (<HTMLElement>color).style.backgroundColor="#f8d7da";
    }
    return mensajeDias;
  }

  /**
   * Ordena ascendentemente la bandeja
   * @param nameData
   * @param type
   */
  sortAscDes(nameData, type){
    this.tableFilter.sort((x,y) => {
      let a = x[nameData].toLowerCase();
      let b = y[nameData].toLowerCase();
      let operaction;
      if(type === 'up'){
        // tslint:disable-next-line: no-unused-variable
        operaction =  (a > b) ?  1 : (a < b) ?- 1: 0;
      }else{
        // tslint:disable-next-line: no-unused-variable
        operaction =  (a > b) ? - 1 : (a < b) ? 1: 0;
      }
      return  operaction;
    })

  }

  /**
   * Ordena descendentemente la bandeja
   * @param nameData
   * @param type
   */
  sortAscDesNumber(nameData, type){
    this.tableFilter.sort((x,y) => {
      let a = x[nameData];
      let b = y[nameData];
      let operaction;
      if(type === 'up'){
        // tslint:disable-next-line: no-unused-variable
        operaction =  (a > b) ?  1 : (a < b) ?- 1: 0;
      }else{
        // tslint:disable-next-line: no-unused-variable
        operaction =  (a > b) ? - 1 : (a < b) ? 1: 0;
      }
      return  operaction;
    })
  }

  /**
   * Modifica el texto del label del paginador, cantidad de registros por pagina
   * @param page
   * @param pageSize
   * @param length
   */
  private getRangeDisplayText = (page: number, pageSize: number, length: number) => {
    const initialText = `Ver trámites`; // customize this line
    if (length == 0 || pageSize == 0) {
      return `${initialText} 0 of ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex =
      startIndex < length
        ? Math.min(startIndex + pageSize, length)
        : startIndex + pageSize;
    return `${initialText} ${startIndex + 1} a ${endIndex} de ${length}`; // customize this line
  };

}
